import { render, staticRenderFns } from "./ModalObjectsImageUpload.vue?vue&type=template&id=1db276c0&scoped=true"
import script from "./ModalObjectsImageUpload.vue?vue&type=script&lang=js"
export * from "./ModalObjectsImageUpload.vue?vue&type=script&lang=js"
import style0 from "./ModalObjectsImageUpload.vue?vue&type=style&index=0&id=1db276c0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db276c0",
  null
  
)

export default component.exports